var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleDotPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12941",
    "data-name": "Group 12941",
    transform: "translate(-956 -1555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_868",
    "data-name": "Ellipse 868",
    transform: "translate(956 1555)",
    fill: "#fff",
    stroke: "#7979E1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_869",
    "data-name": "Ellipse 869",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(960 1559)",
    fill: "#7979E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleDotPurple);
export default __webpack_public_path__ + "static/media/DoubleDotPurple.1b8f8769137bca27fa9a87751ed29e64.svg";
export { ForwardRef as ReactComponent };